import template from './highway.jade';
import validation from '../../../services/validation';
import debouncePromise from 'debounce-promise';
import uuid from 'node-uuid';
import { trackHighwayAdd, trackHighwayDistanceChange } from '../tracking/tracking';

export default angular
  .module('cian.addForm.highway', [])
  .directive('isHighwaySelected', () => {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: (scope, element, attrs, ngModel) => {
        ngModel.$validators.selected = value => {
          value = scope.viewModel.viewValue;
          if (angular.isObject(value)) {
            return value.name && !value.id ? false : true;
          }
          return !value || !value.trim() ? true : false;
        };
      }
    };
  })
  .directive('cianAfAddressHighway', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller: ['apiService', '$scope', '$q', 'addressService', 'analyticsService', 'deviceService',
    function (apiService, $scope, $q, addressService, analyticsService, deviceService) {
      this.isMobile = deviceService.isMobile;
      // максимальное кол-во шоссе
      this.maxCount = 2;
      this.loadingSuggestions = [];
      this.isFocused = false;
      this.ad.geo = this.ad.geo || {};
      this.ad.geo.highways = this.ad.geo.highways || [];

      this.highwayValidation = validation(this.form, undefined, {
        selected: 'Неверное название шоссе',
        // unique: 'Шоссе уже указано'
      });

      // видимость тултипа, показываем ошибку только когда в модель записано невалидное значение
      this.isHighwayInvalid = (index) => {
        const isModelValid = Array.isArray(this.highways) ? this.isSet(index) : true;
        return !isModelValid && this.highwayValidation.invalid(`geo.highways.${index}.id`);
      };

      this.distanceValidation = validation(this.form, undefined, {
        parse: 'Введите число',
        min: 'Неверно указано расстояние',
        max: 'Превышено максимальное значение',
        required: 'Укажите расстояние'
      });

      this.isSet = (index) => this.highways[index].id || !this.highways[index].name;

      this.isEnabled = () => addressService.isHighwayEnabled();
      this.isUndergroundButtonVisible = () => {
        return (!this.ad.geo.undergrounds || !this.ad.geo.undergrounds.length) && addressService.isUndergroundEnabled();
      };

      const getSuggestions = (queryText, index) => {
        if (!queryText || !addressService.geoObject) return $q.when([]);

        const query = {
          term: queryText,
          locationId: addressService.geoObject.locationId
        };

        const selected = this.viewModels
          .map(vm => vm.viewValue && vm.viewValue.id)
          .filter(id => id);
        this.loadingSuggestions[index] = true;
        return apiService.roads(query, { cache: true })
          .then(data => {
            const roads = data.data.roads.filter(h => !selected.includes(h.id));
            if (roads.length === 1 && !this.isFocused) {
              const viewModel = {
                highway: this.highways[index],
                viewValue: roads[0]
              };
              this.updateModel(viewModel);
              updateViewModels();
            }
            return roads;
          }).finally(()=> {
            this.loadingSuggestions[index] = false;
          });
      };

      this.getSuggestions = debouncePromise(getSuggestions, 600);

      this.focusInput = () => {
        this.isFocused = true;
      };

      this.blurInput = (viewModel) => {
        this.isFocused = false;
        this.updateModel(viewModel, true);
      };

      const updateViewModels = () => {
        this.highways.forEach(h => {
          if (!h.uuid) h.uuid = uuid.v4();
        });
        this.viewModels = this.highways.map(highway => {
          return {
            highway,
            viewValue: { id: highway.id, name: highway.name } // сюда пишет typeahead
          };
        });
      };

      const findFirst = () => {
        return this.highways.find(u => u.id) || this.highways.find(u => u.name) || this.highways[0];
      };

      // https://github.com/angular-ui/bootstrap/issues/5136
      this.forceValidation = el => {
        el.$validate();
      };

      this.updateModel = (viewModel, isTrackingDisabled) => {
        const viewValue = viewModel.viewValue ;
        const newHighway = angular.isObject(viewValue) ? viewValue : { id: null, name: viewValue || '' };
        Object.assign(viewModel.highway, newHighway);

        if (!isTrackingDisabled) {
          trackHighwayAdd(viewModel.highway.id || '', analyticsService.adAnalyticsCategory);
        }

        if (!viewModel.highway.name) {
          viewModel.highway.distance = '';
          if (viewModel.highway.isDefault) {
            this.setDefault(findFirst());
          }
        } else if (this.highways.filter(h => h.id || h.name).length == 1) {
          this.setDefault(viewModel.highway); // переключаем дефолт с неактивных
        }
      };

      this.addHighway = () => {
        this.highways.push({
          name: ''
        });
        if (this.highways.length === 1) {
          this.highways[0].isDefault = true;
        }
        updateViewModels();
      };

      this.deleteHighway = highway => {
        const index = this.highways.indexOf(highway);
        if (index > -1) {
          this.highways.splice(index, 1);
          this.loadingSuggestions.splice(index, 1);
        }
        if (this.highways.length === 0) {
          this.addHighway();
        }
        else if (highway.isDefault) {
          this.setDefault(findFirst());
        }
        updateViewModels();
      };

      this.setDefault = highway => {
        this.highways.forEach(u => {
          u.isDefault = u === highway;
        });
      };

      $scope.$watch(() => this.ad.geo.highways, highways => {
        this.highways = this.ad.geo.highways || [];
        if (this.highways.length > 0 && !this.highways.find(u => u.isDefault)) {
          this.highways[0].isDefault = true;
        }

        if (this.highways.length === 0) this.addHighway();

        updateViewModels();
      });

      this.showUnderground = () => {
        this.ad.geo.undergrounds = [{
          name: '',
          transportType: 'walk'
        }];
      };

      let oldDistance = 0;

      this.startHighwayDistanceEditing = (viewModel) => {
        oldDistance = viewModel.highway.distance;
      };

      this.endHighwayDistanceEditing = (viewModel) => {
        if (oldDistance !== viewModel.highway.distance && !!viewModel.highway.distance) {
          trackHighwayDistanceChange(analyticsService.adAnalyticsCategory);
        }

        oldDistance = 0;
      };

      const onAddressChanged = (geoObject, init) => {
        if (init || !geoObject) return;
        if (!addressService.isHighwayEnabled()) {
          this.highways.splice(0, this.highways.length);
          this.loadingSuggestions.splice(0, this.highways.length);
          this.addHighway();
        }
        updateViewModels();
      };

      $scope.$on('geo.address.changed', (event, address, geoObject, isValid, locationChanged, init, isJk) => onAddressChanged(geoObject, init));

      addressService.highwayFieldEnabled = true;

      $scope.$on('$destroy', () => {
        addressService.highwayFieldEnabled = false;
      });
    }],
    controllerAs: 'ctrl',
    template,
    replace: true,
  }))
  .name;
